'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-13d783d6.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var MinusIcon = styled__default['default'].button.withConfig({ displayName: "ww-uikit_MinusIcon_kzpdgyty", componentId: "sc-khrii4" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    display: block;\n    padding: 0;\n    border: none;\n    background: none;\n    &:before,\n    &:after {\n        display: block;\n        position: relative;\n        content: '';\n        width: ", "px;\n        height: ", "px;\n    }\n    &:after {\n        right: 0;\n        border-top: 1px solid ", ";\n    }\n"], ["\n    display: block;\n    padding: 0;\n    border: none;\n    background: none;\n    &:before,\n    &:after {\n        display: block;\n        position: relative;\n        content: '';\n        width: ", "px;\n        height: ", "px;\n    }\n    &:after {\n        right: 0;\n        border-top: 1px solid ", ";\n    }\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? 9 : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 9 : _b;
    return size;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal60;
});
var templateObject_1;

exports.default = MinusIcon;
//# sourceMappingURL=index.js.map
